<i18n src="./../../i18n/info_page.json"></i18n>

<template>
    <div id="info-page">
        <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
        <div class="container-fluid" v-if="loaded">
            <navigation-bar/>

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-news-page-1.jpg">
                <div class="container">
                    <h1 class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;" v-text="$t('header')"/>
                </div>
            </div>

            <div class="container-fluid mt-subpage-section m-0 p-0">
                <div class="container-fluid m-0 p-0">
                    <div class="lazy container-fluid">
                        <div class="container">
                            <div class="content-container p-3 pt-5">
                                <div class="row grid" data-masonry='{ "itemSelector": ".grid-item" }'>
                                    <div class="grid-item col-lg-4 col-12" v-for="info in content" :key="info.title">
                                        <div class="card">
                                            <router-link :to="{name: 'infoPage', params: {pageName: cleanPath(info.url)}}">
                                                <img class="lazy card-img-top" :data-src="info.image" :alt="info.imageAlt">
                                            </router-link>
                                            <div class="card-body">
                                                <router-link :to="{name: 'infoPage', params: {pageName: cleanPath(info.url)}}">
                                                    <h5 class="card-title pb-0 mb-0" v-text="info.title"/>
                                                </router-link>
                                                <p class="card-text"><small class="text-muted" v-text="info.date"/></p>
                                                <p class="card-text" v-text="info.summary"/>
                                            </div>
                                            <div class="card-footer p-0">
                                                <router-link :to="{name: 'infoPage', params: {pageName: cleanPath(info.url)}}" class="btn btn-block"><small v-text="$t('readMore')"/></router-link>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <main-footer/>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import axios from "axios";
    import {Const} from "@/main";
    import $ from "jquery";
    import LazyLoad from "vanilla-lazyload";
    import Masonry from "masonry-layout"

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "InfoPage",
        components: {MainFooter, NavigationBar},
        data () {
            return {
                locale: this.$i18n.locale,
                content: {},
                loaded: false,
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted() {
            axios.get(`${Const.API_HOST}/${this.locale}/content/info`)
                .then(function (response) {
                    return response.data;
                }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(body => {
                this.content = body
                this.loaded = true

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                    let mansoryReload = function () {
                        var row = document.querySelector("[data-masonry]");
                        new Masonry(row, {
                                itemSelector: ".grid-item"
                            }
                        )
                    }
                    setTimeout(mansoryReload, 50);
                    setTimeout(mansoryReload, 100);
                    setTimeout(mansoryReload, 200);
                    setTimeout(mansoryReload, 500);
                    setInterval(mansoryReload, 1000);
                })
            });

            $(document).scroll(function () {
                var $nav = $(".navbar-light");
                $nav.removeClass('initial');
                $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
            });
        },
        methods: {
            cleanPath(path) {
                return path.startsWith('/') ? path.substring(1) : path;
            }
        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }

    .grid-item {
        margin-bottom: 30px;
    }

    .card-footer {
        background-color: #295d92;
    }

    .card-footer a {
        color: #fff;
    }

    .card-footer a:hover {
        color: #4092e5
    }

    .card:hover {
        box-shadow: 0 0 30px -15px rgba(0, 0, 0, 0.2);
        transition: box-shadow 0.1s ease-in-out;
    }
</style>